import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { MICRO } from '@/constants/type'
import { siteConfig, studio } from '@/constants/site'

export const Footer: FC = (): ReactNode => {
    return (
        <footer className='px-6 pb-8 pt-24 sm:px-12 sm:pb-10 sm:pt-32'>
            <div className='h-px w-full' style={{ background: 'var(--fz-rule)' }} />

            <div className='mt-6 flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between'>
                <div className='flex flex-col gap-3'>
                    <span
                        className='font-serif text-[19px] leading-none tracking-[-0.01em]'
                        style={{ color: 'var(--fz-ink)' }}
                    >
                        {siteConfig.name}
                    </span>

                    <span className={MICRO} style={{ color: 'var(--fz-faint)' }}>
                        {studio.cities.join(' · ')} — Est. {studio.founded}
                    </span>
                </div>

                <div className='flex flex-wrap items-center gap-x-8 gap-y-3'>
                    <a
                        href={`mailto:${studio.email}`}
                        className={`${MICRO} transition-colors duration-300`}
                        style={{ color: 'var(--fz-faint)' }}
                    >
                        {studio.email}
                    </a>

                    <Link
                        href='/contact'
                        className={`${MICRO} transition-colors duration-300`}
                        style={{ color: 'var(--fz-faint)' }}
                    >
                        Enquiries
                    </Link>

                    <Link
                        href='/'
                        className={`${MICRO} transition-colors duration-300`}
                        style={{ color: 'var(--fz-faint)' }}
                    >
                        Work
                    </Link>
                </div>
            </div>
        </footer>
    )
}
